// IMPORTANT: Ensure breakpoints are in sync with 'frontend/src/app/globals.css'
export const breakpoints = {
    sm: '40rem', // 640px
    md: '48rem', // 768px
    lg: '64rem', // 1024px
    xl: '80rem', // 1280px
    '2xl': '96rem', // 1536px
    // 3840px
} as const;

export type Breakpoint = keyof typeof breakpoints;
const keys = Object.keys(breakpoints) as Breakpoint[];

function up(key: Breakpoint) {
    return `(min-width:${breakpoints[key]})`;
}

function down(key: Breakpoint) {
    return `(max-width: calc(${breakpoints[key]} - 1px))`;
}

function between(start: Breakpoint, end: Breakpoint) {
    return `${up(start)} and ${down(end)}`;
}

function only(key: Breakpoint) {
    if (keys.indexOf(key) + 1 < keys.length) {
        return between(key, keys[keys.indexOf(key) + 1]);
    }

    return up(key);
}

function not(key: Breakpoint) {
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
        return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
        return down(keys[keyIndex]);
    }

    return between(key, keys[keys.indexOf(key) + 1]);
}
export const breakpointUtils = { up, down, between, only, not };
